import React from 'react';
import { Box, Link, List, ListItem } from '@material-ui/core';
import Typography from '../../../components/atoms/Typography';
import useStyles from './style';
import { get } from 'lodash';
import RichText from '../../../components/atoms/RichText';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { decodeHTML } from '../../../utils/decodeHTML';
import { canUseDOM } from '../../../utils/canUseDOM';
const CalenderScheduleDescription = (props) => {
  const { sitecoreContext } = props
  const scheduleData = get(sitecoreContext, 'route.fields.scheduleData.value', '')
  const location = get(sitecoreContext, 'route.fields.location.value', '')
  const phoneNumber = get(sitecoreContext, 'route.fields.phoneNumber.value', '')
  const websiteUrl = get(sitecoreContext, 'route.fields.websiteUrl.value.href', '')
  const emailMailto = get(sitecoreContext, 'route.fields.email.value.href', '')
  const email = get(sitecoreContext, 'route.fields.email.value.url', '')
  const facebookUrl = get(sitecoreContext, 'route.fields.facebookUrl.value.href', '')
  const instagramUrl = get(sitecoreContext, 'route.fields.instagramUrl.value.href', '')
  const twitterUrl = get(sitecoreContext, 'route.fields.twitterUrl.value.href', '')
  const youtubeUrl = get(sitecoreContext, 'route.fields.youtubeUrl.value.href', '')
  const wechat = get(sitecoreContext, 'route.fields.wechat.value.href', '')
  const linktype = get(sitecoreContext, 'route.fields.websiteUrl.value.linktype', '')
  const classes = useStyles();
  const urlWithoutProtocol = websiteUrl.replace(/^https?:\/\//, "");
  const urlWithoutEndUrl = urlWithoutProtocol.replace(/\/.*$/, "");

  const createSVG = (type = '', fill = '', customClass = '') => {
    switch (type) {
      case 'facebook':
        return (
          <svg className={customClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="black" />
            <path d="M13.5872 8.66042H14.5V7.07042C14.3425 7.04875 13.8009 7 13.1701 7C11.854 7 10.9524 7.82792 10.9524 9.34958V10.75H9.5V12.5275H10.9524V17H12.7331V12.5279H14.1267L14.3479 10.7504H12.7326V9.52583C12.7331 9.01208 12.8714 8.66042 13.5872 8.66042Z" fill="white" />
          </svg>
        )
        break;
      case 'twitter':
        return (
          <svg className={customClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="black" />
            <g clip-path="url(#clip0_136_6264)">
              <path d="M10.4904 9.37673H9.60182L13.5256 14.6224H14.4141L10.4904 9.37673Z" fill="white" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2505 11.9996C17.2505 14.8989 14.8999 17.2492 12.0003 17.2492C9.10063 17.2492 6.75 14.8989 6.75 11.9996C6.75 9.10033 9.10063 6.75 12.0003 6.75C14.8999 6.75 17.2505 9.10033 17.2505 11.9996ZM11.2755 12.3132L8.76596 8.95814H10.7001L12.3454 11.1576L14.3815 8.95814H14.9499L12.5993 11.4973L15.2501 15.041H13.3159L11.5296 12.6527L9.31855 15.041H8.75014L11.2755 12.3132Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_136_6264">
                <rect width="10.5" height="10.5" fill="white" transform="translate(6.75 6.75)" />
              </clipPath>
            </defs>
          </svg>

        )
        break;
      case 'wechat':
        return (
          <svg className={customClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="black" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.375 10.5714C6.375 8.59929 8.29357 7 10.6607 7C12.7521 7 14.4914 8.24929 14.8686 9.90071C14.66 9.875 14.4486 9.85714 14.2321 9.85714C11.8686 9.85714 9.94643 11.4593 9.94643 13.4286C9.94643 13.6579 9.975 13.8814 10.025 14.0993C9.65857 14.0543 9.31571 13.9579 8.98571 13.8407L7.44643 14.5L8.01143 13.37C7.01643 12.7171 6.375 11.7086 6.375 10.5714ZM8.69643 9.14286C8.69643 9.43857 8.93643 9.67857 9.23214 9.67857C9.52786 9.67857 9.76786 9.43857 9.76786 9.14286C9.76786 8.84714 9.52786 8.60714 9.23214 8.60714C8.93643 8.60714 8.69643 8.84714 8.69643 9.14286ZM12.0893 9.67857C11.7936 9.67857 11.5536 9.43857 11.5536 9.14286C11.5536 8.84714 11.7936 8.60714 12.0893 8.60714C12.385 8.60714 12.625 8.84714 12.625 9.14286C12.625 9.43857 12.385 9.67857 12.0893 9.67857ZM14.2321 10.5714C16.2043 10.5714 17.8036 11.8507 17.8036 13.4286C17.8036 14.3421 17.2579 15.1464 16.4236 15.6693L17.0893 17L15.1643 16.175C14.865 16.24 14.5564 16.2857 14.2321 16.2857C12.26 16.2857 10.6607 15.0064 10.6607 13.4286C10.6607 11.8507 12.26 10.5714 14.2321 10.5714ZM12.625 12.7143C12.625 13.01 12.865 13.25 13.1607 13.25C13.4564 13.25 13.6964 13.01 13.6964 12.7143C13.6964 12.4186 13.4564 12.1786 13.1607 12.1786C12.865 12.1786 12.625 12.4186 12.625 12.7143ZM15.3036 13.25C15.0079 13.25 14.7679 13.01 14.7679 12.7143C14.7679 12.4186 15.0079 12.1786 15.3036 12.1786C15.5993 12.1786 15.8393 12.4186 15.8393 12.7143C15.8393 13.01 15.5993 13.25 15.3036 13.25Z" fill="white" />
          </svg>
        )
        break;
      case 'youtube':
        return (
          <svg className={customClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="black" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.922 8.55748C16.3809 8.68105 16.7427 9.04279 16.8661 9.5017C17.0956 10.3399 17.0868 12.087 17.0868 12.087C17.0868 12.087 17.0868 13.8251 16.8663 14.6634C16.7427 15.1222 16.381 15.484 15.922 15.6075C15.0838 15.8281 11.7309 15.8281 11.7309 15.8281C11.7309 15.8281 8.38674 15.8281 7.53974 15.5987C7.08084 15.4751 6.71916 15.1134 6.59559 14.6546C6.375 13.8251 6.375 12.0781 6.375 12.0781C6.375 12.0781 6.375 10.3399 6.59559 9.5017C6.71903 9.04286 7.08967 8.67222 7.53968 8.54878C8.37792 8.32812 11.7308 8.32812 11.7308 8.32812C11.7308 8.32812 15.0838 8.32812 15.922 8.55748ZM13.4515 12.0781L10.6633 10.4723V13.684L13.4515 12.0781Z" fill="white" />
          </svg>
        )
        break;
      case 'instagram':
        return (
          <svg className={customClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#FF8707" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7859 7.23828H10.2145C8.57102 7.23828 7.23828 8.57102 7.23828 10.2145V13.7859C7.23828 15.4294 8.57102 16.7621 10.2145 16.7621H13.7859C15.4294 16.7621 16.7621 15.4294 16.7621 13.7859V10.2145C16.7621 8.57102 15.4294 7.23828 13.7859 7.23828ZM15.8692 13.7859C15.8692 14.9347 14.9347 15.8692 13.7859 15.8692H10.2145C9.06566 15.8692 8.13114 14.9347 8.13114 13.7859V10.2145C8.13114 9.06566 9.06566 8.13114 10.2145 8.13114H13.7859C14.9347 8.13114 15.8692 9.06566 15.8692 10.2145V13.7859ZM14.778 9.52003C14.778 9.6844 14.6447 9.81765 14.4803 9.81765C14.316 9.81765 14.1827 9.6844 14.1827 9.52003C14.1827 9.35566 14.316 9.22241 14.4803 9.22241C14.6447 9.22241 14.778 9.35566 14.778 9.52003ZM9.61923 12.0002C9.61923 10.6853 10.6853 9.61923 12.0002 9.61923C13.3151 9.61923 14.3811 10.6853 14.3811 12.0002C14.3811 13.3151 13.3151 14.3811 12.0002 14.3811C10.6853 14.3811 9.61923 13.3151 9.61923 12.0002ZM10.5121 12.0002C10.5121 12.8204 11.1799 13.4883 12.0002 13.4883C12.8204 13.4883 13.4883 12.8204 13.4883 12.0002C13.4883 11.1794 12.8204 10.5121 12.0002 10.5121C11.1799 10.5121 10.5121 11.1794 10.5121 12.0002Z" fill="white" />
          </svg>
        )
        break;
      default:
        return <></>
    }
  }

  // function extractDatesFromHTML(target) {
  //   // Ensure target is not null or undefined
  //   if (!target) {
  //     console.error('Target is undefined or null.');
  //     return null;
  //   }

  //   // Ensure eventItem exists
  //   const eventItem = target;
  //   if (!eventItem) {
  //     console.error('No .sch-evnt-item found in the provided HTML.');
  //     return null;
  //   }

  //   // Get the date range text from the first <p> tag inside the .evnt-sch-time class
  //   const dateRangeElement = eventItem.querySelector('.evnt-sch-time p');
  //   if (!dateRangeElement) {
  //     console.error('No date range element found.');
  //     return null;
  //   }
  //   const dateRangeText = dateRangeElement.innerText.trim();

  //   // Get the time range text from the second <p> tag inside the .evnt-sch-time class
  //   const timeRangeElements = eventItem.querySelectorAll('.evnt-sch-time p');
  //   if (timeRangeElements.length < 2) {
  //     console.error('No time range element found.');
  //     return null;
  //   }
  //   const timeRangeText = timeRangeElements[1].innerText.trim();

  //   // Extract year from the date range string
  //   const yearMatch = dateRangeText.match(/\d{4}/);
  //   if (!yearMatch) {
  //     console.error('Year not found in date range text.');
  //     return null;
  //   }
  //   const year = yearMatch[0];

  //   // Remove the year from the date string before splitting
  //   const dateRangeWithoutYear = dateRangeText.replace(`, ${year}`, '');

  //   // Split the date range into start and end dates
  //   const dateParts = dateRangeWithoutYear.split(' - ');
  //   if (dateParts.length !== 2) {
  //     console.error('Start and end dates not properly formatted.');
  //     return null;
  //   }
  //   const [startDateText, endDateText] = dateParts;

  //   // Convert the date strings into Date objects with the extracted year
  //   const startDate = new Date(`${startDateText}, ${year}`);
  //   const endDate = new Date(`${endDateText}, ${year}`);

  //   // Validate the created dates
  //   if (isNaN(startDate) || isNaN(endDate)) {
  //     console.error('Invalid dates parsed.');
  //     return null;
  //   }

  //   // Return an object containing the start date, end date, and time range
  //   return {
  //     startDate: startDate.toDateString(),
  //     endDate: endDate.toDateString(),
  //     timeRange: timeRangeText,
  //   };
  // }

  // function extractDateTimeRange(startDate, endDate, timeRange) {
  //   const options = { month: 'short', day: '2-digit' };

  //   // Parse the start and end dates
  //   let start = new Date(startDate);
  //   let end = new Date(endDate);

  //   // Validate the start and end dates
  //   if (isNaN(start) || isNaN(end)) {
  //     console.error('Invalid start or end date.');
  //     return '';
  //   }

  //   // Initialize an empty array to store the result
  //   let result = "";

  //   // Loop through the range of dates
  //   while (start <= end) {
  //     let formattedDate = start.toLocaleDateString('en-US', options);

  //     const eventDiv = canUseDOM && document.createElement('div'); // Create div for each event day
  //     eventDiv.className = 'evnt-sch-time';  // Set class name

  //     const dateP = canUseDOM && document.createElement('p');  // Create <p> for date
  //     dateP.textContent = formattedDate;  // Set date text
  //     eventDiv.appendChild(dateP);

  //     const timeP = canUseDOM && document.createElement('p');  // Create <p> for time range
  //     timeP.textContent = timeRange;  // Set time range text
  //     eventDiv.appendChild(timeP);

  //     result += eventDiv.outerHTML;

  //     // Increment the date by 1 day
  //     start.setDate(start.getDate() + 1);
  //   }

  //   return result.toString();
  // }

  // function rearrangeScheduleData(htmlData) {
  //   if (!htmlData || !htmlData.value) {
  //     console.error('htmlData is missing or invalid.');
  //     return '';
  //   }

  //   let htmlString = htmlData.value;
  //   console.log('[htmlString]:', htmlString)

  //   // Create a dummy div to manipulate the HTML string
  //   let tempDiv = canUseDOM && document.createElement('div');
  //   tempDiv.innerHTML = htmlString;

  //   // Get all elements with class 'sch-evnt-item'
  //   const eventItems = tempDiv.querySelectorAll('.sch-evnt-item');
  //   console.log('[eventItems]:', eventItems)

  //   if (!eventItems.length) {
  //     console.error('No event items found.');
  //     return tempDiv.innerHTML;
  //   }

  //   // Loop through each event item and replace the content
  //   eventItems.forEach((eventItem) => {
  //     const extractedDetails = extractDatesFromHTML(eventItem);
  //     console.log('[extractedDetails]:', extractedDetails)

  //     if (extractedDetails) {
  //       const newContent = extractDateTimeRange(extractedDetails.startDate, extractedDetails.endDate, extractedDetails.timeRange);

  //       // Clear the current content in the 'evnt-sch-time' section
  //       const schTimeSection = eventItem.querySelector('.evnt-sch-time');
  //       if (schTimeSection) {
  //         schTimeSection.classList.remove('evnt-sch-time');
  //         schTimeSection.innerHTML = ''; // Clear the old content

  //         // Append the newly generated HTML
  //         schTimeSection.innerHTML = newContent;
  //       } else {
  //         console.error('evnt-sch-time section not found in event item.');
  //       }
  //     } else {
  //       console.error('Failed to extract event details.');
  //     }
  //   });

  //   return tempDiv.innerHTML;
  // }

  const isTargetBlank = linktype === "external" ? '_blank' : '';

  const isContactInfo = function () {
    return !!phoneNumber || !!email || !!instagramUrl || !!facebookUrl || !!twitterUrl || !!wechat || !!youtubeUrl
  }();
  return (
    <Box className={classes.root}>
      {!!location &&
        <Box className={classes.contentBox}>
          <Box className={classes.innerHeading}>
            <Typography animateSettings={{ willAnimate: false }} className='mainHeading' variant="body3Bold" component="h4">{getDictionaryText('ADLocation')}</Typography>
          </Box>
          <Box className={classes.innerContent}>
            <List className='listWrapper'>
              <ListItem>
                <Typography animateSettings={{ willAnimate: false }} className='listItem' variant="body3" component="p">{location}</Typography>
              </ListItem>
            </List>
          </Box>
        </Box>}
      {isContactInfo && (
        <Box className={classes.contentBox}>
          <Box className={classes.innerHeading}>
            <Typography animateSettings={{ willAnimate: false }} className='mainHeading' variant="body3Bold" component="h4">{getDictionaryText('ADContactInfo')}</Typography>
          </Box>
          <Box className={classes.innerContent}>
            <List className='listWrapper'>
              {!!email && <ListItem>
                <Link className='listItem' variant="body3" href={emailMailto}>{email}</Link>
              </ListItem>}
              {!!phoneNumber && <ListItem>
                <Link className='listItem' variant="body3" href={`tel: ${phoneNumber}`}>{phoneNumber}</Link>
              </ListItem>}
              <ListItem className='listItem'>
                <Box className='socialWrapper'>
                  {/* added checks for 'https://' and 'http://' in the social links to address the issue mentioned in this ticket: https://createmedia-group.atlassian.net/browse/CAD-274  */}
                  {!!instagramUrl && instagramUrl != 'https://' && instagramUrl != 'http://' && <Link className='socialIcon' target={isTargetBlank} href={instagramUrl}>{createSVG('instagram')}</Link>}
                  {!!facebookUrl && facebookUrl != 'https://' && facebookUrl != 'http://' && <Link className='socialIcon' target={isTargetBlank} href={facebookUrl}>{createSVG('facebook')}</Link>}
                  {!!twitterUrl && twitterUrl != 'https://' && twitterUrl != 'http://' && <Link className='socialIcon' target={isTargetBlank} href={twitterUrl}>{createSVG('twitter')}</Link>}
                  {!!wechat && wechat != 'https://' && wechat != 'http://' && <Link className='socialIcon' target={isTargetBlank} href={wechat}>{createSVG('wechat')}</Link>}
                  {!!youtubeUrl && youtubeUrl != 'https://' && youtubeUrl != 'http://' && <Link className='socialIcon' target={isTargetBlank} href={youtubeUrl}>{createSVG('youtube')}</Link>}
                </Box>
              </ListItem>
            </List>
          </Box>
        </Box>)}
      {!!websiteUrl && <Box className={classes.contentBox}>
        <Box className={classes.innerHeading}>
          <Typography animateSettings={{ willAnimate: false }} className='mainHeading' variant="body3Bold" component="h4">{getDictionaryText('ADWebsite')}</Typography>
        </Box>
        <Box className={classes.innerContent}>
          <List className='listWrapper'>
            <ListItem>
              <Link className='listItem' variant="body3" target={isTargetBlank} href={websiteUrl}>
                {urlWithoutEndUrl}
              </Link>
            </ListItem>
          </List>
        </Box>
      </Box>}

    </Box >
  )
};

export default CalenderScheduleDescription;
